import { ReactNode, useContext } from "react";

import { VStack } from "../../internal/exports";

import { ContributionContext } from "../context";

export function Focusable({ children }: { children: ReactNode }) {
  const { onClick, cardHeading, cardDescription, headingId, descriptionId } =
    useContext(ContributionContext);

  if (!onClick)
    return (
      <VStack w="full" align="normal" gap={4}>
        {children}
      </VStack>
    );

  const getAriaProps = () => {
    if (cardHeading && cardDescription) {
      return {
        "aria-labelledby": headingId,
        "aria-describedby": descriptionId
      };
    }
    if (cardHeading && !cardDescription) {
      return {
        "aria-labelledby": headingId
      };
    }

    return { "aria-label": `${cardHeading} ${cardDescription}` };
  };

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    onClick();
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (onClick && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <VStack
      w="full"
      h="full"
      align="normal"
      gap={4}
      {...getAriaProps()}
      role="button"
      tabIndex={0}
      cursor="pointer"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      _focusVisible={{ boxShadow: "outline", outline: "none" }}
    >
      {children}
    </VStack>
  );
}
